export const ContentTypeSetter = (slug: string): string => {
  const contentType = slug.includes('unternehmen/stories/') ? 'stories' : 'pages';
  return contentType;
};
